import { render, staticRenderFns } from "./_offers.componentV2.vue?vue&type=template&id=6e646c80&scoped=true"
import script from "./_offers.componentV2.vue?vue&type=script&lang=js"
export * from "./_offers.componentV2.vue?vue&type=script&lang=js"
import style0 from "./_offers.componentV2.vue?vue&type=style&index=0&id=6e646c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e646c80",
  null
  
)

export default component.exports